import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { PRODUCT_TYPES, ROLES } from '@moal/api'
import PropTypes from 'prop-types'
import { useContext, useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import * as SETTINGS from '../../../constants/settings'
import { AuthenticationContext } from '../../../context/authenticationContext'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import { hasStaffPrivilege } from '../../../utils/RequireRole'
import { getAdditionalSubs, modNameChanger } from '../../../utils/utilities'
import RegistrationDate from '../../Utilities/RegistrationDate'

const UserInfoWidget = ({ message, user, setExpandedUserInfoWidget }) => {
  const { getSubType } = useContext(AuthenticationContext)
  const { productsService, [SETTINGS.MEMBERSHIPS.key]: memberships } =
    useContext(SiteConfigContext)
  const [marginTop, setMarginTop] = useState('0px')
  const elementRef = useRef(null)
  const [subType] = useState(getSubType({ user: message.user }))

  useEffect(() => {
    const element = elementRef.current
    const rect = element.getBoundingClientRect()
    const windowHeight = window.innerHeight
    const chatForm = document
      .getElementById('chat-form')
      .getBoundingClientRect()
    if (rect.y + rect.height > windowHeight - chatForm.height) {
      setMarginTop(
        `${windowHeight - (rect.y + rect.height + chatForm.height)}px`
      )
    }
  }, [])

  const renderName = () => {
    const isStaff = hasStaffPrivilege(user)
    const userName = message.user.userService.profile.name

    if (isStaff) {
      return (
        <Link
          className="link"
          to={`/mod/private-messages?id=${message.user.userService._id}`}
        >
          {userName}
        </Link>
      )
    } else {
      return modNameChanger(message)
    }
  }

  return (
    <div
      className="user-info-widget border-y bg-neutral-100 dark:bg-neutral-900 dark:border-neutral-800 absolute z-10 p-2 shadow-lg w-full -ml-2"
      style={{ marginTop }}
      ref={elementRef}
    >
      <div className="flex flex-row justify-between items-center">
        <h3 className="flex font-bold">{renderName()}</h3>
        <button onClick={() => setExpandedUserInfoWidget(null)}>
          <FontAwesomeIcon
            icon={faTimesCircle}
            className="h-4 transition-all text-black/50 dark:text-white/50 hover:text-red-500"
          />
        </button>
      </div>
      <Titles
        role={message.user.role.role}
        subType={subType}
        memberships={memberships}
      />
      <RegistrationDate message={message} />
      <Memberships
        productsService={productsService}
        userSubscriptions={message.user.userService.subscriptions}
      />
    </div>
  )
}

UserInfoWidget.propTypes = {
  message: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  setExpandedUserInfoWidget: PropTypes.func.isRequired
}

const Titles = ({ role, subType, memberships }) => {
  if (role === ROLES.HOST) {
    return <h4>Host</h4>
  }
  if (role === ROLES.EXPERT) {
    return <h4>Expert</h4>
  }
  if (role === ROLES.MODERATOR || role === ROLES.ADMIN) {
    return <h4>Moderator</h4>
  }

  if (role === ROLES.SUBSCRIBER) {
    return (
      <>
        {memberships.main.map((bdg) => {
          return subType === bdg.subType && <h4>{bdg.title}</h4>
        })}
      </>
    )
  }

  return null
}

Titles.propTypes = {
  role: PropTypes.string.isRequired,
  subType: PropTypes.string.isRequired,
  memberships: PropTypes.object
}

const Memberships = ({ productsService, userSubscriptions }) => {
  const allMemberSubs = [...getAdditionalSubs(userSubscriptions)]
  const badgesForMember = []

  // Process PRODUCTS.BUNDLE
  badgesForMember.push(
    ...productsService[PRODUCT_TYPES.BUNDLE].filter((product) =>
      allMemberSubs.includes(product.itemNumber)
    )
  )

  // THERES NO WAY THIS DID ANYTHING???
  // Process PRODUCTS.FUNNEL
  // productsService[PRODUCT_TYPES.FUNNEL].forEach((product) => {
  //   const matches = product.products
  //     .map((id) =>
  //       productsService[PRODUCT_MAP.OTHER_PRODUCTS].find((each) => each._id === id)
  //     )
  //     .filter((match) => match && allMemberSubs.includes(match.itemNumber))

  //   badgesForMember.push(...matches)
  // })

  if (badgesForMember.length < 1) {
    return <div />
  }

  return (
    <div className="mt-2 gap-1 flex flex-col">
      <p className="font-bold">Memberships</p>
      <div className="gap-1 flex items-center">
        {badgesForMember.map((product, index) => (
          <div
            key={index}
            className="w-[56px] h-[56px] flex items-center justify-center border border-brand-primary-500 dark:border-brand-primary-800 rounded-full shadow-inner dark:shadow-black/60 bg-white dark:bg-neutral-900"
          >
            <img
              className="w-[40px] h-[40px]"
              src={product?.graphics?.icon?.dark}
              title={product?.displayName}
              alt={product?.displayName}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

Memberships.propTypes = {
  userSubscriptions: PropTypes.array.isRequired,
  memberships: PropTypes.object
}

export default UserInfoWidget
